import common from '../common'

export default {
    list(params) {
        return common.get('/rocheManage/sys/sysAnnouncementSend/getMyAnnouncementSendAll',params);
    },

    readCount(params) {
        return common.get('/rocheManage/sys/sysAnnouncementSend/queryUnReadCount',params);
    },

    myMessages(params) {
        return common.get('/rocheManage/sys/sysAnnouncementSend/getMyAnnouncementSend',params);
    },

    readAll(params) {
        return common.put('/rocheManage/sys/sysAnnouncementSend/readAll',params);
    },

    getUnApproveCount(params) {
        return common.get('/rocheManage/meeting/pubMeeting/getUnApproveCount',params);
    },

    readMessageByAnntId(params) {
        return common.put('/rocheManage/sys/sysAnnouncementSend/editByAnntIdAndUserId',params);
    },
}


// WEBPACK FOOTER //
// ./src/api/messages/list.js